import { mobileBtn, mainMenu, mainMenuItems } from '../base';

/**
 * Función para abrir enlaces externos en una nueva pestaña.
 */
function openExternalLinks() {
  const links = document.querySelectorAll('a');

  links.forEach(link => {
    if (link.hostname !== window.location.hostname) {
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
    }
  });
}

document.addEventListener('DOMContentLoaded', openExternalLinks);






